import type { ReactElement } from "react"
import { useState } from "react"
import type { Term } from "@onestore/api/types"
import ArrowLinkAtm from "@onestore/hel/dist/components/atoms/ArrowLinkAtm"
import TextAtm from "@onestore/hel/dist/components/atoms/TextAtm"
import AnimateHeightOrg from "@onestore/hel/dist/components/organisms/AnimateHeightOrg"
import FlexContainerOrg from "@onestore/hel/dist/components/organisms/FlexContainerOrg"
import PushOrg from "@onestore/hel/dist/components/organisms/PushOrg"
import _t from "@core/i18n"
import MarkdownText from "@gatsby-plugin-generic-page/components/Markdown/Text"
import getBaseMarkdownOverrides from "@gatsby-plugin-generic-page/helpers/getBaseMarkdownOverrides"
import { sendContentShowEvent } from "~/lib/analytics"

type ModalExpendableAgreementProps = {
  name: Term["name"]
  text: Term["text"]
  isExpanded?: boolean
}

const ModalExpendableAgreement = ({
  name,
  text,
  isExpanded,
}: ModalExpendableAgreementProps): ReactElement<ModalExpendableAgreementProps> => {
  const [isExpandedState, setIsExpandedState] = useState<boolean>(!!isExpanded)

  return (
    <div>
      <FlexContainerOrg alignItems="baseline" justifyContent="space-between">
        <TextAtm typography="big2">{name}</TextAtm>

        {!!text ? (
          <PushOrg leftSpace={2}>
            <ArrowLinkAtm
              title={
                isExpandedState
                  ? _t("checkout.terms.hide")
                  : _t("checkout.terms.show")
              }
              typography="nano3"
              arrowDirection={isExpandedState ? "up" : "down"}
              arrowColor="default"
              onClick={() => {
                if (!isExpandedState) {
                  sendContentShowEvent()
                }

                setIsExpandedState((value) => !value)
              }}
            >
              {isExpandedState
                ? _t("checkout.terms.hide")
                : _t("checkout.terms.show")}
            </ArrowLinkAtm>
          </PushOrg>
        ) : null}
      </FlexContainerOrg>

      {!!text ? (
        <AnimateHeightOrg isOpen={isExpandedState} paddingTopSpace={1}>
          <MarkdownText
            components={getBaseMarkdownOverrides({
              typography: "medium1_h",
              boldTypography: "medium2_h",
            })}
            hasBoldedLinks
            hasOpenedLinksInNewTab
          >
            {text}
          </MarkdownText>
        </AnimateHeightOrg>
      ) : null}
    </div>
  )
}

export default ModalExpendableAgreement
